// Kenyan mobile network prefixes

export const safaricomPrefixes = [
  "700", "701", "702", "703", "704", "705", "706", "707", "708", "709",
  "710", "711", "712", "713", "714", "715", "716", "717", "718", "719",
  "720", "721", "722", "723", "724", "725", "726", "727", "728", "729",
  "740", "741", "742", "743", "744", "745", "746", "747", "748", "749",
  "757", "758", "759",
  "768", "769",
  "790", "791", "792", "793", "794", "795", "796", "797", "798", "799",
  "110", "111", "112", "113", "114", "115",
];

export const airtelPrefixes = [
  "730", "731", "732", "733", "734", "735", "736", "737", "738", "739",
  "750", "751", "752", "753", "754", "755", "756",
  "762", "763", "764", "765", "766", "767",
  "780", "781", "782", "783", "784", "785", "786", "787", "788", "789",
  "100", "101", "102", "103", "104", "105", "106", "107", "108",
];

export const telkomPrefixes = [
  "770", "771", "772", "773", "774", "775", "776", "777", "778", "779",
];

export const airtelLogo = "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/airtel-logo-icon.png";
export const telkomLogo = "https://simpauldesign.com/wp-content/uploads/2019/02/telkom-kenya.png";
